export default "__VITE_ASSET__C9VnY$38__"